/** Format a price string for display with adaptive precision. */
export function formatPrice(price: string | number, decimals?: number): string {
  const n = typeof price === 'string' ? parseFloat(price) : price;
  if (!Number.isFinite(n)) return '—';

  if (decimals != null) {
    return n.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }

  // Adaptive precision: show more decimals for very small values
  if (n === 0) return '0.00';
  const abs = Math.abs(n);
  let digits: number;
  if (abs >= 1) digits = 2;
  else if (abs >= 0.01) digits = 4;
  else if (abs >= 0.0001) digits = 6;
  else digits = 8;

  return n.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: digits,
  });
}

/** Format a volume number. */
export function formatVolume(vol: string | number): string {
  const n = typeof vol === 'string' ? parseFloat(vol) : vol;
  if (!Number.isFinite(n)) return '—';
  if (n >= 1_000_000_000) return `${(n / 1_000_000_000).toFixed(2)}B`;
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(2)}K`;
  return n.toFixed(4);
}

/** Format a percentage. */
export function formatPct(pct: string | number): string {
  const n = typeof pct === 'string' ? parseFloat(pct) : pct;
  if (!Number.isFinite(n)) return '—';
  const sign = n > 0 ? '+' : '';
  return `${sign}${n.toFixed(2)}%`;
}

/** Format a timestamp as HH:MM:SS. */
export function formatTime(ts: number): string {
  return new Date(ts).toLocaleTimeString('en-US', { hour12: false });
}

/** Format a timestamp as YYYY-MM-DD HH:MM. */
export function formatDateTime(ts: number): string {
  const d = new Date(ts);
  return `${d.toLocaleDateString('en-CA')} ${d.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' })}`;
}
